/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfDocument } from '../../models/data-page-of-document';

export interface DocumentCatList$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
  pageNumber?: number;
  sortbydirection?: string | null;
  category?: string | null;
  searchText?: string | null;
}

export function documentCatList(http: HttpClient, rootUrl: string, params?: DocumentCatList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfDocument>> {
  const rb = new RequestBuilder(rootUrl, documentCatList.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('sortbydirection', params.sortbydirection, {});
    rb.query('category', params.category, {});
    rb.query('searchText', params.searchText, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfDocument>;
    })
  );
}

documentCatList.PATH = '/documentcat/list';
